// extracted by mini-css-extract-plugin
export default {"audit-saved":"audit-saved","holder":"holder","icon-holder":"icon-holder","icon":"icon","main-text":"main-text","sub-text":"sub-text","continue-btn":"continue-btn"};